import './style.scss';

export function faqs_block() {
    const block = document.querySelector('.faqs_block');
    if (!block) return;
    
    const faqsWrapper   = block.querySelector('.Faqs-wrapper');
    const fraction      = block.querySelector('.fraction-wrapper');
    const currentNode   = fraction?.querySelector('.current');
    const totalNode     = fraction?.querySelector('.total');
    
    const prevBtn       = block.querySelector('.button-prev');
    const nextBtn       = block.querySelector('.button-next');
    
    const ajaxUrl       = block.getAttribute('data-ajax-url');
    const nonce         = block.getAttribute('data-nonce');
    const ppp           = parseInt(block.getAttribute('data-ppp'), 10) || 5;
    const order         = (block.getAttribute('data-order') || 'asc').toLowerCase();
    const locationVal   = block.getAttribute('data-location') || '';
    const selectedFaqs  = block.getAttribute('data-selected-faqs') || '';
    
    let currentPage     = parseInt(block.getAttribute('data-current'), 10) || 1;
    let totalPages      = parseInt(block.getAttribute('data-total'), 10) || 1;
    let isLoading       = false;
    
    // ✅ افتح أول بانِل عند أول تحميل
    initAccordion(block, /*openFirst=*/ true);
    
    if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (isLoading || prevBtn.classList.contains('button-disabled')) return;
            loadPage(currentPage - 1);
        });
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (isLoading || nextBtn.classList.contains('button-disabled')) return;
            loadPage(currentPage + 1);
        });
    }
    
    async function loadPage(targetPage) {
        if (targetPage < 1 || targetPage > totalPages) return;
        
        isLoading = true;
        setButtonsState(true);
        
        try {
            const form = new FormData();
            form.append('action', 'ez_load_faqs');
            form.append('nonce', nonce);
            form.append('page',  targetPage);
            form.append('ppp',   ppp);
            form.append('order', order);
            if (locationVal) form.append('location', locationVal);
            if (selectedFaqs) form.append('selected_faqs', selectedFaqs);
            
            const res  = await fetch(ajaxUrl, { method: 'POST', body: form, credentials: 'same-origin' });
            const json = await res.json();
            
            if (!json?.success) throw new Error('AJAX failed');
            
            if (faqsWrapper) {
                faqsWrapper.innerHTML = json.data.html || '<p>No FAQs found.</p>';
            }
            
            currentPage = Number(json.data.current) || targetPage;
            totalPages  = Number(json.data.total)   || totalPages;
            
            if (currentNode) currentNode.textContent = String(currentPage);
            if (totalNode)   totalNode.textContent   = String(totalPages);
            
            toggleDisabled(prevBtn, !json.data.has_prev);
            toggleDisabled(nextBtn, !json.data.has_next);
            
            // ✅ بعد ما نجيب الصفحة الجديدة، افتح أول بانِل
            initAccordion(block, /*openFirst=*/ true);
            
            try {
                const url = new URL(window.location.href);
                if (currentPage > 1) url.searchParams.set('paged', String(currentPage));
                else url.searchParams.delete('paged');
                window.history.replaceState({}, '', url.toString());
            } catch (e) {}
        } catch (err) {
            console.error(err);
        } finally {
            isLoading = false;
            setButtonsState(false);
        }
    }
    
    function toggleDisabled(btn, shouldDisable) {
        if (!btn) return;
        btn.classList.toggle('button-disabled', !!shouldDisable);
        btn.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    }
    
    function setButtonsState(disabled) {
        [prevBtn, nextBtn].forEach((btn) => {
            if (!btn) return;
            btn.classList.toggle('is-loading', disabled);
        });
    }
    
    // --- Accordion Logic ---
    function initAccordion(scopeEl, openFirst = false) {
        const accordion = scopeEl.querySelector('.accordion');
        if (!accordion) return;
        
        // نحذف أي event listeners قديمة
        const cloned = accordion.cloneNode(true);
        accordion.parentNode.replaceChild(cloned, accordion);
        
        const acc = scopeEl.querySelector('.accordion');
        if (!acc) return;
        
        // افتح أول بانِل فقط لو مفيش بانِل مفتوح أصلاً
        if (openFirst) {
            const alreadyOpen = acc.querySelector('.accordion-trigger[aria-expanded="true"]');
            if (!alreadyOpen) {
                const firstPanel = acc.querySelector('.accordion-panel');
                if (firstPanel) {
                    setPanelState(firstPanel, true);
                    closeSiblings(firstPanel);
                }
            }
        }
        
        acc.addEventListener('click', (e) => {
            // نتأكد إن المستخدم ضغط على الزرار نفسه
            const btn = e.target.closest('.accordion-trigger');
            if (!btn || !acc.contains(btn)) return;
            
            const panel = btn.closest('.accordion-panel');
            if (!panel) return;
            
            const isOpen = btn.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
                setPanelState(panel, false);
            } else {
                closeSiblings(panel);
                setPanelState(panel, true);
            }
        });
    }
    
    function setPanelState(panelEl, open) {
        const btn = panelEl.querySelector('.accordion-trigger');
        const cnt = panelEl.querySelector('.accordion-content');
        if (!btn || !cnt) return;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        cnt.setAttribute('aria-hidden',   open ? 'false' : 'true');
    }
    
    function closeSiblings(panelEl) {
        const acc = panelEl.closest('.accordion');
        if (!acc) return;
        acc.querySelectorAll('.accordion-panel').forEach((p) => {
            if (p !== panelEl) setPanelState(p, false);
        });
    }
}
